import performanceImage from '../media/performance.svg';
import recommendationsImage from '../media/recommendations.svg';
import campaignsImage from '../media/campaigns.svg';
import topChangesImage from '../media/top-changes.svg';
import conversionTrackingImage from '../media/conversion-tracking.svg';
import keywordsImage from '../media/keywords.svg';
import searchTermsImage from '../media/search-terms.svg';
import devicesImage from '../media/devices.svg';
import competitionImage from '../media/competition.svg';
import adGroupsImage from '../media/ad-groups.svg';
import accountsImage from '../media/accounts.svg';
import topLocationsImage from '../media/top-locations.svg';

export const CARD_CONFIG = {
  'CardType-Performance': {
    icon: performanceImage,
    title: _TL_('Performance'),
    description: _TL_('View your campaigns\' key performance data all in one place'),
  },
  'CardType-Recommendations': {
    icon: recommendationsImage,
    title: _TL_('Recommendations'),
    description: _TL_('View key untapped strategies to ensure that you are getting the most out of your Microsoft advertising experience.'),
  },
  'CardType-TopCampaigns': {
    icon: campaignsImage,
    title: _TL_('Campaigns'),
    description: _TL_('View your top campaigns of interest based on their performance data.'),
  },
  'CardType-TopChanges-Campaign': {
    icon: topChangesImage,
    title: _TL_('Top changes'),
    description: _TL_('Identify which campaigns and ad groups are responsible for the biggest changes to your account.'),
  },
  'CardType-TopChanges-Account': {
    icon: topChangesImage,
    title: _TL_('Top changes'),
    description: _TL_('Identify which accounts are responsible for the biggest changes.'),
  },
  'CardType-TopChanges-AdGroup': {
    icon: topChangesImage,
    title: _TL_('Top changes'),
    description: _TL_('Identify which campaigns and ad groups are responsible for the biggest changes to your account.'),
  },
  'CardType-Conversion-Tracking': {
    icon: conversionTrackingImage,
    title: _TL_('Conversion tracking'),
    description: _TL_('Conversions track website actions to measure campaign performance.'),
  },
  'CardType-TopKeyword': {
    icon: keywordsImage,
    title: _TL_('Keywords'),
    description: _TL_('View your top keywords of interest based on their performance data.'),
  },
  'CardType-TopSearchTerms': {
    icon: searchTermsImage,
    title: _TL_('What people searched'),
    description: _TL_('Get a quick glance into what queries potential customers are searching for to trigger your ads.'),
  },
  'CardType-Device': {
    icon: devicesImage,
    title: _TL_('Devices'),
    description: _TL_('Get insights on how your campaigns perform by device type.'),
  },
  'CardType-Competition': {
    icon: competitionImage,
    title: _TL_('Competition'),
    description: _TL_('View your campaign\'s key performance data all in one place.'),
  },
  'CardType-TopLocations': {
    icon: topLocationsImage,
    title: _TL_('Top locations'),
    description: _TL_('Highlights the top 10 best performing locations within the location targets you initially set.'),
  },
  'CardType-TopAdGroup': {
    icon: adGroupsImage,
    title: _TL_('Ad groups'),
    description: _TL_('View your top ad groups of interest based on their performance data.'),
  },
  'CardType-TopAccounts': {
    icon: accountsImage,
    title: _TL_('Accounts'),
    description: _TL_('View your top accounts of interest based on their performance data.'),
  },
};
